import { ActivityDetail } from "@/domain/entity/prescription/prescription-info-entity";
import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchActivityDetailUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(activityUuid: string): Promise<SATResult<ActivityDetail, SATError>> {
    return this.prescriptionRepo.fetchActivityDetail(activityUuid);
  }
}
